import * as Sentry from '@sentry/react';
import { StoreEnhancer, StoreEnhancerStoreCreator } from 'redux';

// only boolean and keys should stay, because there is a lot of sensitive information in the store
const sanitizeObject = (object: Record<string, unknown>): Record<string, unknown> =>
  Object.entries(object).reduce((result, [key, value]) => {
    let newValue: unknown;
    if (typeof value === 'boolean') {
      newValue = value;
    } else if (typeof value === 'object') {
      if (value !== null) {
        newValue = sanitizeObject(value as Record<string, unknown>);
      }
    }
    return { ...result, [key]: newValue };
  }, {});

const withSentryEnhancer = (enhancer: StoreEnhancer): StoreEnhancer => {
  if (window.env.SENTRY_USE !== 'true') {
    return enhancer;
  }
  const sentryEnhancer = Sentry.createReduxEnhancer({
    // disabled: there is no useful information in the action
    actionTransformer: () => null,
    stateTransformer: sanitizeObject,
  });

  return (next: StoreEnhancerStoreCreator) => sentryEnhancer(enhancer(next));
};

export default withSentryEnhancer;
